var composition = {
  rest: 0,
  events: [
    {
      note: 'D3',
      velocity: 0.8,
      time: '0:0:0',
      duration: '0:1:0',
      change: true,
      circleOn: 1,
      circleOff: 0
    },
    {
      note: 'A3',
      velocity: 0.55,
      time: '0:0:2',
      duration: '0:0:2'
    },
    {
      note: 'F#3',
      velocity: 0.72,
      time: '0:1:0',
      duration: '0:0:2'
    },
    {
      note: 'G3',
      velocity: 0.88,
      time: '0:1:2',
      duration: '0:0:2'
    },
    {
      note: 'D3',
      velocity: 0.8,
      time: '0:2:0',
      duration: '0:1:0'
    },
    {
      note: 'A3',
      velocity: 0.58,
      time: '0:2:2',
      duration: '0:0:2'
    },
    {
      note: 'F#3',
      velocity: 0.55,
      time: '0:3:0',
      duration: '0:0:2'
    },
    {
      note: 'G3',
      velocity: 0.81,
      time: '0:3:2',
      duration: '0:0:2'
    },
    {
      note: 'D3',
      velocity: 0.8,
      time: '1:0:0',
      duration: '0:1:0'
    },
    {
      note: 'A3',
      velocity: 0.84,
      time: '1:0:2',
      duration: '0:0:2'
    },
    {
      note: 'F#3',
      velocity: 0.65,
      time: '1:1:0',
      duration: '0:0:2'
    },
    {
      note: 'G3',
      velocity: 0.50,
      time: '1:1:2',
      duration: '0:0:2'
    },
    {
      note: 'B3',
      velocity: 0.96,
      time: '1:2:0',
      duration: '0:0:2'
    },
    {
      note: 'A3',
      velocity: 0.55,
      time: '1:2:2',
      duration: '0:0:2'
    },
    {
      note: 'G3',
      velocity: 0.92,
      time: '1:3:0',
      duration: '0:0:2'
    },
    {
      note: 'C3',
      velocity: 0.8,
      time: '1:3:2',
      duration: '0:1:0'
    },
    {
      note: 'A3',
      velocity: 0.80,
      time: '2:0:0',
      duration: '0:0:2'
    },
    {
      note: 'F#3',
      velocity: 0.55,
      time: '2:0:2',
      duration: '0:0:2'
    },
    {
      note: 'G3',
      velocity: 0.84,
      time: '2:1:0',
      duration: '0:0:2'
    },
    {
      note: 'C3',
      velocity: 0.8,
      time: '2:1:2',
      duration: '0:1:0'
    },
    {
      note: 'A3',
      velocity: 0.81,
      time: '2:2:0',
      duration: '0:0:2'
    },
    {
      note: 'F#3',
      velocity: 0.86,
      time: '2:2:2',
      duration: '0:0:2'
    },
    {
      note: 'G3',
      velocity: 0.50,
      time: '2:3:0',
      duration: '0:0:2'
    },
    {
      note: 'C3',
      velocity: 0.8,
      time: '2:3:2',
      duration: '0:1:0'
    },
    {
      note: 'A3',
      velocity: 0.90,
      time: '3:0:0',
      duration: '0:0:2'
    },
    {
      note: 'F#3',
      velocity: 0.81,
      time: '3:0:2',
      duration: '0:0:2'
    },
    {
      note: 'G3',
      velocity: 0.48,
      time: '3:1:0',
      duration: '0:0:2'
    },
    {
      note: 'B3',
      velocity: 0.96,
      time: '3:1:2',
      duration: '0:0:2'
    },
    {
      note: 'A3',
      velocity: 0.86,
      time: '3:2:0',
      duration: '0:0:2'
    },
    {
      note: 'G3',
      velocity: 0.95,
      time: '3:2:2',
      duration: '0:0:2'
    },
    // CHANGE CIRCLE
    {
      note: 'D4',
      velocity: 0.8,
      time: '3:3:0',
      duration: '0:1:0',
      change: true,
      circleOn: 2,
      circleOff: 1
    },
    {
      note: 'A4',
      velocity: 0.55,
      time: '3:3:2',
      duration: '0:0:2'
    },
    {
      note: 'F#4',
      velocity: 0.72,
      time: '4:0:0',
      duration: '0:0:2'
    },
    {
      note: 'G4',
      velocity: 0.88,
      time: '4:0:2',
      duration: '0:0:2'
    },
    {
      note: 'D4',
      velocity: 0.8,
      time: '4:1:0',
      duration: '0:1:0'
    },
    {
      note: 'A4',
      velocity: 0.58,
      time: '4:1:2',
      duration: '0:0:2'
    },
    {
      note: 'F#4',
      velocity: 0.55,
      time: '4:2:0',
      duration: '0:0:2'
    },
    {
      note: 'G4',
      velocity: 0.81,
      time: '4:2:2',
      duration: '0:0:2'
    },
    {
      note: 'D4',
      velocity: 0.8,
      time: '4:3:0',
      duration: '0:1:0'
    },
    {
      note: 'A4',
      velocity: 0.84,
      time: '4:3:2',
      duration: '0:0:2'
    },
    {
      note: 'F#4',
      velocity: 0.65,
      time: '5:0:0',
      duration: '0:0:2'
    },
    {
      note: 'G4',
      velocity: 0.50,
      time: '5:0:2',
      duration: '0:0:2'
    },
    {
      note: 'B4',
      velocity: 0.96,
      time: '5:1:0',
      duration: '0:0:2'
    },
    {
      note: 'A4',
      velocity: 0.55,
      time: '5:1:2',
      duration: '0:0:2'
    },
    {
      note: 'G4',
      velocity: 0.92,
      time: '5:2:0',
      duration: '0:0:2'
    },
    {
      note: 'C4',
      velocity: 0.8,
      time: '5:2:2',
      duration: '0:1:0'
    },
    {
      note: 'A4',
      velocity: 0.80,
      time: '5:3:0',
      duration: '0:0:2'
    },
    {
      note: 'F#4',
      velocity: 0.55,
      time: '5:3:2',
      duration: '0:0:2'
    },
    {
      note: 'G4',
      velocity: 0.84,
      time: '6:0:0',
      duration: '0:0:2'
    },
    {
      note: 'C4',
      velocity: 0.8,
      time: '6:0:2',
      duration: '0:1:0'
    },
    {
      note: 'A4',
      velocity: 0.81,
      time: '6:1:0',
      duration: '0:0:2'
    },
    {
      note: 'F#4',
      velocity: 0.86,
      time: '6:1:2',
      duration: '0:0:2'
    },
    {
      note: 'G4',
      velocity: 0.50,
      time: '6:2:0',
      duration: '0:0:2'
    },
    {
      note: 'C4',
      velocity: 0.8,
      time: '6:2:2',
      duration: '0:1:0'
    },
    {
      note: 'A4',
      velocity: 0.90,
      time: '6:3:0',
      duration: '0:0:2'
    },
    {
      note: 'F#4',
      velocity: 0.81,
      time: '6:3:2',
      duration: '0:0:2'
    },
    {
      note: 'G4',
      velocity: 0.48,
      time: '7:0:0',
      duration: '0:0:2'
    },
    {
      note: 'B4',
      velocity: 0.96,
      time: '7:0:2',
      duration: '0:0:2'
    },
    {
      note: 'A4',
      velocity: 0.86,
      time: '7:1:0',
      duration: '0:0:2'
    },
    {
      note: 'G4',
      velocity: 0.95,
      time: '7:1:2',
      duration: '0:0:2'
    },
    // CHANGE
    {
      note: 'D2',
      velocity: 0.8,
      time: '7:2:0',
      duration: '0:1:0',
      change: true,
      circleOn: 0,
      circleOff: 2
    },
    {
      note: 'A2',
      velocity: 0.55,
      time: '7:2:2',
      duration: '0:0:2'
    },
    {
      note: 'F#2',
      velocity: 0.72,
      time: '7:3:0',
      duration: '0:0:2'
    },
    {
      note: 'G2',
      velocity: 0.88,
      time: '7:3:2',
      duration: '0:0:2'
    },
    {
      note: 'D2',
      velocity: 0.8,
      time: '8:0:0',
      duration: '0:1:0'
    },
    {
      note: 'A2',
      velocity: 0.58,
      time: '8:0:2',
      duration: '0:0:2'
    },
    {
      note: 'F#2',
      velocity: 0.55,
      time: '8:1:0',
      duration: '0:0:2'
    },
    {
      note: 'G2',
      velocity: 0.81,
      time: '8:1:0',
      duration: '0:0:2'
    },
    {
      note: 'D2',
      velocity: 0.8,
      time: '8:1:2',
      duration: '0:1:0'
    },
    {
      note: 'A2',
      velocity: 0.84,
      time: '8:2:0',
      duration: '0:0:2'
    },
    {
      note: 'F#2',
      velocity: 0.65,
      time: '8:2:2',
      duration: '0:0:2'
    },
    {
      note: 'G2',
      velocity: 0.50,
      time: '8:3:0',
      duration: '0:0:2'
    },
    {
      note: 'B2',
      velocity: 0.96,
      time: '8:3:2',
      duration: '0:0:2'
    },
    {
      note: 'A2',
      velocity: 0.55,
      time: '9:0:0',
      duration: '0:0:2'
    },
    {
      note: 'G2',
      velocity: 0.92,
      time: '9:0:2',
      duration: '0:0:2'
    },
    {
      note: 'C2',
      velocity: 0.8,
      time: '9:1:0',
      duration: '0:1:0'
    },
    {
      note: 'A2',
      velocity: 0.80,
      time: '9:1:2',
      duration: '0:0:2'
    },
    {
      note: 'F#2',
      velocity: 0.55,
      time: '9:2:0',
      duration: '0:0:2'
    },
    {
      note: 'G2',
      velocity: 0.84,
      time: '9:2:2',
      duration: '0:0:2'
    },
    {
      note: 'C2',
      velocity: 0.8,
      time: '9:3:0',
      duration: '0:1:0'
    },
    {
      note: 'A2',
      velocity: 0.81,
      time: '9:3:2',
      duration: '0:0:2'
    },
    {
      note: 'F#2',
      velocity: 0.86,
      time: '10:0:0',
      duration: '0:0:2'
    },
    {
      note: 'G2',
      velocity: 0.50,
      time: '10:0:2',
      duration: '0:0:2'
    },
    {
      note: 'C2',
      velocity: 0.8,
      time: '10:1:0',
      duration: '0:1:0'
    },
    {
      note: 'A2',
      velocity: 0.90,
      time: '10:1:2',
      duration: '0:0:2'
    },
    {
      note: 'F#2',
      velocity: 0.81,
      time: '10:2:0',
      duration: '0:0:2'
    },
    {
      note: 'G2',
      velocity: 0.48,
      time: '10:2:2',
      duration: '0:0:2'
    },
    {
      note: 'B2',
      velocity: 0.96,
      time: '10:3:0',
      duration: '0:0:2'
    },
    {
      note: 'A2',
      velocity: 0.86,
      time: '10:3:2',
      duration: '0:0:2'
    },
    {
      note: 'G2',
      velocity: 0.95,
      time: '11:0:0',
      duration: '0:0:2'
    }

  ],
  start: 0,
};

export { composition };
